const AROMA_PREFIX = '/aroma-report/'
const PUBLIC_AROMA_PATHS = [
  '/aroma-report/login',
  '/aroma-report/profile',
  '/aroma-report/bind-guide',
  '/aroma-report/scanner'
]

export function normalizeAromaRedirect (target, sn) {
  if (!target) return ''
  try {
    const url = new URL(target, 'https://aroma.local')
    if (url.origin !== 'https://aroma.local') return ''
    if (!url.pathname.startsWith(AROMA_PREFIX)) return ''
    if (PUBLIC_AROMA_PATHS.includes(url.pathname)) return ''
    const redirectSn = url.searchParams.get('sn') || ''
    if (redirectSn !== (sn || '')) return ''
    return `${url.pathname}${url.search}${url.hash}`
  } catch (error) {
    return ''
  }
}

export function getAromaEntryLocation (sn, redirect) {
  const safeRedirect = normalizeAromaRedirect(redirect, sn)
  if (safeRedirect) return safeRedirect
  return sn
    ? { path: '/aroma-report/list', query: { sn } }
    : { path: '/aroma-report/list' }
}
